(function () {
  'use strict';

  // ═══ SCROLL REVEAL ═══
  var revealEls = document.querySelectorAll('.hw-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('hw-reveal--visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('hw-reveal--visible'); });
  }

  // ═══ STATS COUNTER ═══
  function animateCounter(el) {
    var target = parseFloat(el.dataset.target);
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var decimals = (target % 1 !== 0) ? 1 : 0;
    var duration = 1800;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = eased * target;
      el.textContent = prefix + current.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var statsEls = document.querySelectorAll('.hw-stat__num[data-target]');
  if (statsEls.length && 'IntersectionObserver' in window) {
    var statsObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCounter(e.target);
          statsObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    statsEls.forEach(function (el) { statsObs.observe(el); });
  }

  // ═══ HERO BLOB PARALLAX ═══
  var hero = document.querySelector('.hw-hero');
  if (hero && window.matchMedia('(min-width: 900px)').matches) {
    var blob1 = hero.querySelector('.hw-blob--1');
    var blob2 = hero.querySelector('.hw-blob--2');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (blob1) blob1.style.transform = 'translateY(' + (y * 0.07) + 'px)';
          if (blob2) blob2.style.transform = 'translateY(' + (y * -0.05) + 'px)';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ═══ REDUCE MOTION ═══
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var style = document.createElement('style');
    style.textContent = '.hw * { animation-duration: .01ms !important; transition-duration: .01ms !important; }';
    document.head.appendChild(style);
  }

})();
